import { INITIAL_STATE } from './index';
import { ActionTypes } from '../actions/user';

const defaultUser = {
  idClienteNavision: null,
  idUserApp: null,
  name: null,
  roles: null,
  sign: null,
  account: null,
  lastConnection: '',
  documentsId: null
};

export const currentUser = (state = defaultUser, action = {}) => {
  switch (action.type) {
    case ActionTypes.SET_CURRENT_USER:
      return {
        ...state,
        ...action.payload
      };
    case ActionTypes.APPLICATION_LAST_CONNECTION: {
      return {...state, lastConnection: action.payload};
    }
    case ActionTypes.CURRENT_USER_CREDENTIALS_CLEAR:
      return {...state, ...INITIAL_STATE.currentUser };

    case ActionTypes.DOCUMENTS_ID_CLEAR:
      return {...state, documentsId: action.payload };
    default:
      return state;
  }
};
